import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import MediaCustomizations from './media-customizations-model'
import {
  CreateMediaCustomizationsAsync,
  DeleteMediaCustomizationsAsync,
  LoadMediaCustomizationssAsync,
} from './mediaCustomizations-thunk'
const initialState: mediaCustomizationsSliceState = {
  mediaCustomizations: [],
  selected_mediaCustomizations: '',
  is_loading_mediaCustomizations: false,
  is_creating_mediaCustomizations: false,
  is_deleting_mediaCustomizations: false,
}
export interface mediaCustomizationsSliceState {
  mediaCustomizations: MediaCustomizations[]
  selected_mediaCustomizations?: string
  is_loading_mediaCustomizations: boolean
  is_creating_mediaCustomizations: boolean
  is_deleting_mediaCustomizations: boolean
}
export const mediaCustomizationsSlice = createSlice({
  name: 'mediaCustomizations',
  initialState,
  reducers: {
    setSelectedmediaCustomizations: (state, action) => {
      state.selected_mediaCustomizations = action.payload
    },
    clearStatemediaCustomizations: (state) => {
      state.mediaCustomizations = []
      state.is_loading_mediaCustomizations = false
      state.is_creating_mediaCustomizations = false
      state.is_deleting_mediaCustomizations = false
    },
    mergemediaCustomizations: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_mediaCustomizations = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.mediaCustomizations = merge(
            state.mediaCustomizations,
            payload,
          ) as any
        }
      }
    },

    add_mediaCustomizations: (state, action) => {
      if (action.payload) {
        state.mediaCustomizations = [
          ...state.mediaCustomizations,
          action.payload,
        ]
      }
    },
    set_mediaCustomizations: (state, action) => {
      let { key, value, id } = action.payload
      state.mediaCustomizations = state.mediaCustomizations.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadMediaCustomizationssAsync.pending, (state) => {
      state.is_loading_mediaCustomizations = true
    })
    builder.addCase(
      LoadMediaCustomizationssAsync.fulfilled,
      (state, action) => {
        state.is_loading_mediaCustomizations = false
        if (action.payload) {
          state.mediaCustomizations = action.payload
        }
      },
    )
    builder.addCase(LoadMediaCustomizationssAsync.rejected, (state) => {
      state.is_loading_mediaCustomizations = false
    })
    builder.addCase(CreateMediaCustomizationsAsync.pending, (state) => {
      state.is_creating_mediaCustomizations = true
    })
    builder.addCase(CreateMediaCustomizationsAsync.fulfilled, (state) => {
      state.is_creating_mediaCustomizations = false
    })
    builder.addCase(CreateMediaCustomizationsAsync.rejected, (state) => {
      state.is_creating_mediaCustomizations = false
    })
    builder.addCase(DeleteMediaCustomizationsAsync.pending, (state) => {
      state.is_deleting_mediaCustomizations = true
    })
    builder.addCase(
      DeleteMediaCustomizationsAsync.fulfilled,
      (state, action) => {
        state.is_deleting_mediaCustomizations = false
        if (state.mediaCustomizations) {
          state.mediaCustomizations = state.mediaCustomizations.filter(
            (x) => action.payload.id !== x.id,
          )
        }
      },
    )
    builder.addCase(DeleteMediaCustomizationsAsync.rejected, (state) => {
      state.is_deleting_mediaCustomizations = false
    })
  },
})

export const {
  clearStatemediaCustomizations,
  setSelectedmediaCustomizations,
  set_mediaCustomizations,
  mergemediaCustomizations,
  add_mediaCustomizations,
} = mediaCustomizationsSlice.actions

export const get_mediaCustomizations =
  (id?: string) =>
  (state: {
    mediaCustomizations: {
      mediaCustomizations: MediaCustomizations[]
    }
  }): MediaCustomizations | null => {
    let temp = state?.mediaCustomizations?.mediaCustomizations?.find(
      (v) => v.id === id,
    )
    if (temp) {
      return temp
    }
    return state?.mediaCustomizations?.mediaCustomizations[0] || null
  }
export const get_selected_mediaCustomizations = (state: {
  mediaCustomizations: mediaCustomizationsSliceState
}): MediaCustomizations | null => {
  let id = state?.mediaCustomizations?.selected_mediaCustomizations
  let temp = state?.mediaCustomizations?.mediaCustomizations?.find(
    (v) => v.id === id,
  )
  if (temp) {
    return temp
  }
  return null
}
export const get_all_mediaCustomizations = (state: {
  mediaCustomizations: {
    mediaCustomizations: MediaCustomizations[]
  }
}): MediaCustomizations[] => {
  let temp = state?.mediaCustomizations?.mediaCustomizations
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_mediaCustomizations_busy = (state: {
  mediaCustomizations: mediaCustomizationsSliceState
}) => {
  return (
    state?.mediaCustomizations.is_deleting_mediaCustomizations ||
    state?.mediaCustomizations.is_loading_mediaCustomizations ||
    state?.mediaCustomizations.is_creating_mediaCustomizations
  )
}
export const is_deleting_mediaCustomizations_busy = (state: {
  mediaCustomizations: mediaCustomizationsSliceState
}) => {
  return state?.mediaCustomizations.is_deleting_mediaCustomizations
}
export const is_loading_mediaCustomizations_busy = (state: {
  mediaCustomizations: mediaCustomizationsSliceState
}) => {
  return state?.mediaCustomizations.is_loading_mediaCustomizations
}
export const is_creating_mediaCustomizations_busy = (state: {
  mediaCustomizations: mediaCustomizationsSliceState
}) => {
  return state?.mediaCustomizations.is_creating_mediaCustomizations
}

export default mediaCustomizationsSlice.reducer
